import * as TYPES from './types';

const initialState: TYPES.Auth = {
  authToken: '',
  errorMessage: '',
  isSignedIn: false,
  isSigningIn: false,
  user: null,
};

export const authReducer = (
  state = initialState,
  { type, payload }: TYPES.ActionType,
): TYPES.Auth => {
  switch (type) {
    case TYPES.SIGNING_IN:
      return { ...state, isSigningIn: true, isSignedIn: false };
    case TYPES.AUTH_USER:
      return { ...state, isSignedIn: true, isSigningIn: false, ...payload };
    case TYPES.SIGN_OUT:
      return initialState;
    case TYPES.AUTH_ERROR:
      return { ...initialState, ...payload };
    default:
      return state;
  }
};
